import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

export type Language = 'ar' | 'en';

interface LanguageContextType {
  language: Language;
  toggleLanguage: () => void;
  t: (key: string, params?: { [key: string]: string | number | undefined }) => string;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

const translations = {
  "ar": {
    // عام
    "app.title": "الجوديا",
    "app.subtitle": "نظام إدارة الفروع والإنتاج",
    "app.logo_alt": "مصنع الجوديا للحلويات",
    "login": "تسجيل الدخول",
    "logout": "تسجيل الخروج",
    "username": "اسم المستخدم",
    "password": "كلمة المرور",
    "dashboard": "لوحة التحكم",
    "save": "حفظ",
    "cancel": "إلغاء",
    "edit": "تعديل",
    "delete": "حذف",
    "add": "إضافة",
    "settings": "الملف الشخصي",
    "header.logout": "تسجيل الخروج",
    "view": "عرض",
    "search": "بحث",
    "filter": "تصفية",
    "date": "التاريخ",
    "status": "الحالة",
    "quantity": "الكمية",
    "price": "السعر",
    "total": "الإجمالي",
    "branch": "الفرع",
    "product": "المنتج",
    "category": "القسم",
    "common.back": "رجوع",
    "common.retry": "إعادة المحاولة",
    "common.loading": "جاري التحميل...",
    "common.debug_info": "معلومات التصحيح",
    "common.user_role": "دور المستخدم",
    "common.token": "الرمز",
    "common.present": "موجود",
    "common.absent": "غير موجود",
    "pagination.previous": "السابق",
    "pagination.next": "التالي",
    "pagination.page": "الصفحة {current} من {total}",
    "orders.total_amount": "المبلغ الإجمالي",
    "orders.date": "تاريخ الطلب",

    // لوحة التحكم الرئيسية
    "admin.dashboard": "لوحة تحكم المدير العام",
    "branch.dashboard": "لوحة تحكم الفرع",
    "chef.dashboard": "لوحة تحكم الشيف",
    "production.dashboard": "لوحة تحكم الإنتاج",
  "orders.review": " الطلبات ",
    "sales.review": " المبيعات ",
    "productionTasks": " مهامي  ",
    "sales.create": " انشاء مبيعات جديدة ",
    "dailyOrdersSummary": " ملخص الطلبات",

    "returns.review": " المرتجعات ",
    // الطلبات
    "dailyOrders": "حركة الطلبات", 
    "orders": "الطلبات",
    "item_completed": "تم إكمال الصنف",
    "item_pending": "بانتظار المراجعة",
    "item_in_progress": "قيد التنفيذ",
    "item_assigned": "مُعين",
    "item_approved": "معتمد",
    "item_rejected": "مرفوض",
    "item_in_production": "قيد الإنتاج",
    "orders.title": "إدارة الطلبات",
    "orders.subtitle": "عرض وإدارة جميع الطلبات",
    "orders.new": "طلبات جديدة",
    "orders.pending": "بانتظار المراجعة",
    "orders.approved": "معتمدة",
    "orders.in_production": "قيد الإنتاج",
    "orders.completed": "مكتملة",
    "orders.delivered": "مُسلمة",
    "orders.cancelled": "ملغاة",
    "orders.in_transit": "في النقل",
    "orders.status": "جميع الحالات",
    "orders.status_pending": "بانتظار المراجعة",
    "orders.status_approved": "معتمدة",
    "orders.status_in_production": "قيد الإنتاج",
    "orders.status_completed": "مكتملة",
    "orders.status_delivered": "مُسلمة",
    "orders.status_cancelled": "ملغاة",
    "orders.status_in_transit": "في النقل",
    "orders.create": "إنشاء طلب جديد",
    "orders.total": "إجمالي الطلبات",
    "orders.allStatuses": "جميع الحالات",
    "orders.all_statuses": "جميع الحالات",
    "orders.branch": "الفرع",
    "orders.items_count": "عدد الأصناف",
    "orders.itemsCount": "عدد الأصناف",
    "orders.totalAmount": "الإجمالي",
    "orders.adjusted_total": "الإجمالي بعد التعديل",
    "orders.currency": "ر.س",
    "orders.notes": "ملاحظات",
    "orders.notes_label": "الملاحظات",
    "orders.order": "طلب",
    "orders.view": "عرض",
    "orders.approve": "اعتماد",
    "orders.cancel": "إلغاء",
    "orders.startProduction": "بدء الإنتاج",
    "orders.complete": "اكتمل",
    "orders.ship": "شحن",
    "orders.loading": "جاري تحميل الطلبات...",
    "orders.fetchError": "فشل في جلب الطلبات",
    "orders.timeoutError": "انتهت مهلة الطلب، يرجى المحاولة مرة أخرى",
    "orders.unauthorized": "غير مصرح، يرجى تسجيل الدخول مرة أخرى",
    "orders.invalidTransition": "لا يمكن تغيير الحالة إلى هذه القيمة",
    "orders.updateError": "حدث خطأ أثناء تحديث حالة الطلب",
    "orders.createError": "حدث خطأ أثناء إنشاء الطلب",
    "orders.formError": "يرجى ملء جميع الحقول المطلوبة",
    "orders.noOrders": "لا توجد طلبات",
    "orders.noOrdersFiltered": "لا توجد طلبات بالحالة أو البحث المحدد",
    "orders.no_orders": "لا توجد طلبات متاحة",
    "orders.no_orders_subtitle": "لم يتم العثور على طلبات مطابقة لمعايير البحث",
    "orders.noOrdersYet": "لم يتم إرسال أي طلبات بعد",
    "orders.filterStatus": "فلترة حسب الحالة",
    "orders.filter_by_status": "تصفية حسب الحالة",
    "orders.search": "البحث في الطلبات",
    "orders.searchPlaceholder": "البحث برقم الطلب أو الفرع أو الملاحظات",
    "orders.orderDetails": "تفاصيل الطلب",
    "orders.order_details": "تفاصيل الطلب #{orderNumber}",
    "orders.order_number": "رقم الطلب",
    "orders.quantity": "الكمية",
    "orders.itemTotal": "إجمالي الصنف",
    "orders.finalTotal": "الإجمالي النهائي",
    "orders.priority": "الأولوية",
    "orders.priority.low": "منخفضة",
    "orders.priority.medium": "متوسطة",
    "orders.priority.high": "عالية",
    "orders.priority.urgent": "عاجلة",
    "orders.priority_low": "أولوية منخفضة",
    "orders.priority_medium": "أولوية متوسطة",
    "orders.priority_high": "أولوية عالية",
    "orders.priority_urgent": "أولوية عاجلة",
    "orders.deliveryDate": "تاريخ التسليم",
    "orders.createdBy": "تم إنشاؤه بواسطة",
    "orders.unknown": "غير معروف",
    "orders.retry": "إعادة المحاولة",
    "orders.previous": "السابق",
    "orders.next": "التالي",
    "orders.sort": "ترتيب حسب",
    "orders.sort_by": "ترتيب حسب",
    "orders.sort.date": "التاريخ",
    "orders.sort_date": "التاريخ",
    "orders.sort.total": "الإجمالي",
    "orders.sort_total_amount": "الإجمالي",
    "orders.sort.priority": "الأولوية",
    "orders.sort_priority": "الأولوية",
    "orders.sort.asc": "تصاعدي",
    "orders.sort.desc": "تنازلي",

    "orders.sort_order": "ترتيب العرض",
    "orders.export": "تصدير كـ CSV",
    "orders.changeStatus": "تغيير الحالة",
    "orders.timeline": "الجدول الزمني للحالة",
    "orders.noNotes": "لا توجد ملاحظات",
    "orders.item": "صنف",
    "orders.items": "الأصناف",
    "orders.addItem": "إضافة صنف",
    "orders.selectBranch": "اختر فرعًا",
    "orders.assign": "تعيين للشيفات",
    "orders.assign_chefs": "تعيين الشيفات",
    "orders.assign_chefs_title": "تعيين الشيفات للطلب #{orderNumber}",
    "orders.assign_chef_to": "تعيين شيف للصنف {product} (الكمية: {quantity})",
    "orders.assignedTo": "معين إلى",
    "orders.unassigned": "غير معين",
    "orders.unassigned_items": "{count} أصناف غير معينة",
    "orders.select_chef": "اختر شيفًا",
    "orders.fetchChefsError": "فشل في جلب بيانات الشيفات",
    "orders.assignError": "يرجى تعيين شيف لكل عنصر",
    "orders.no_chefs_selected": "لم يتم اختيار أي شيف",
    "orders.order_not_approved": "الطلب لم يتم اعتماده بعد",
    "orders.order_not_found": "الطلب غير موجود",
    "orders.status_updated": "تم تحديث حالة الطلب إلى {status}",
    "orders.chefs_assigned": "تم تعيين الشيفات بنجاح",
    "orders.status_history": "سجل الحالة",
    "orders.progress": "التقدم",
    "orders.returned": "مرتجع",
    "orders.reason": "سبب الإرجاع",
    "orders.review_notes": "ملاحظات المراجعة",
    "orders.created_at": "تاريخ الإنشاء",
    "orders.return_status": "حالة المرتجع",
    "orders.orders_count": "عدد الطلبات: {count}",
    "orders.view_order": "عرض الطلب #{orderNumber}",
    "orders.approve_order": "اعتماد الطلب #{orderNumber}",
    "orders.cancel_order": "إلغاء الطلب #{orderNumber}",
    "orders.assign_order": "تعيين الطلب #{orderNumber}",
    "orders.ship_order": "شحن الطلب #{orderNumber}",
    "orders.item_status": "حالة الصنف: {status}",
    "orders.item_pending": "بانتظار التعيين",
    "orders.item_assigned": "معين",
    "orders.item_in_progress": "قيد التنفيذ",
    "orders.item_completed": "مكتمل",
    "orders.item_unknown": "حالة صنف غير معروفة",
    "orders.department": "القسم",
    "orders.status.unknown": "حالة غير معروفة",

    // المرتجعات
    "returns": "المرتجعات",
    "returns.new": "مرتجعات جديدة",
    "returns.pending": "بانتظار المراجعة",
    "returns.approved": "معتمدة",
    "returns.rejected": "مرفوضة",
    "returns.processed": "تمت معالجتها",
    "returns.reason": "سبب الإرجاع",
    "returns.create": "تسجيل مرتجع",
    "returns.review_notes": "ملاحظات المراجعة",
    "returns.created_at": "تاريخ الإنشاء",
    "returns.pending_approval": "بانتظار الموافقة",

    // المخزون
    "inventory": "المخزون",
    "inventory.available": "متوفر",
    "inventory.sold": "مُباع",
    "inventory.returned": "مرتجع",
    "inventory.remaining": "متبقي",
    "orders.updated_at": "إتمام الإنتاج  ",

    // التقارير
    "reports": "الإحصائيات والتقارير",
    "reports.daily": "يومي",
    "reports.weekly": "أسبوعي",
    "reports.monthly": "شهري",
    "reports.yearly": "سنوي",
    "reports.top-branches": "أعلى الفروع طلبًا",
    "reports.low-branches": "أقل الفروع طلبًا",
    "reports.top-products": "أكثر المنتجات طلبًا",
    "returns.top-returns": "أكثر المنتجات إرجاعًا",

    // الفروع
    "branches": "الفروع",
    "branches.manage": "إدارة الفروع",
    "branches.add": "إضافة فرع",
    "branches.name": "اسم الفرع",
    "branches.unknown": "فرع غير معروف",
    "branches.riyadh": "فرع الرياض",
    "branches.jeddah": "فرع جدة",
    "branches.dammam": "فرع الدمام",
    "branches.all_branches": "جميع الفروع",
    "branches.select_branch": "اختر فرعًا",
     "Production-Report": "ملخص الإنتاج",



"orders.more_items": "  أصناف أخرى",
"orders.show_less": "  أصناف أخرى",
    "orders.delivery_completed": "تم إكمال التسليم",
    // الشيفات
    "chefs": "الشيفات",
    "chefs.manage": "إدارة الشيفات",
    "chefs.add": "إضافة شيف",
    "chefs.name": "اسم الشيف",
    "chefs.named": "شيف {name}",
    "chefs.department": "القسم المختص",

    // المبيعات
    "sales": "المبيعات",
    "sales.daily": "مبيعات يومية",
    "sales.register": "تسجيل مبيعة",
    "sales.amount": "قيمة المبيعات",
    "salesReport.title": "تقرير المبيعات",
    "salesReport.subtitle": "إدارة المبيعات ومراقبة الأداء",
    "salesReport.availableProducts": "المنتجات المتاحة",
    "salesReport.noProducts": "لا توجد منتجات متاحة",
    "salesReport.cart": "سلة المبيعات",
    "salesReport.emptyCart": "السلة فارغة",
    "salesReport.previousSales": "المبيعات السابقة",
    "salesReport.noSales": "لا توجد مبيعات",
    "salesReport.filters": "الفلاتر",
    "salesReport.department": "القسم",
    "salesReport.availableStock": "المخزون المتاح",
    "salesReport.unitPrice": "سعر الوحدة",
    "salesReport.addToCart": "إضافة إلى السلة",
    "salesReport.total": "الإجمالي",
    "salesReport.notes": "ملاحظات",
    "salesReport.submitSale": "إرسال المبيعة",
    "salesReport.date": "التاريخ",
    "salesReport.quantity": "الكمية",
    "salesReport.returns": "المرتجعات",
    "salesReport.reason": "السبب",
    "salesReport.branchSales": "مبيعات الفروع",
    "salesReport.productSales": "مبيعات المنتجات",
    "salesReport.departmentSales": "مبيعات الأقسام",
    "salesReport.sale_success": "تم إنشاء المبيعة بنجاح",
    "returns-vs-orders": "المرتجعات مقابل الطلبات",
            "orders.chef_orders": "مهام الإنتاج ",

            "orders.unit": "وحدة",
"orders.start_item": "بدء",
"orders.complete_item": "إكمال",
"orders.reject_item": "رفض",
"orders.item_done": "تم",
"orders.out_of_stock": "نفاد المخزون",
"orders.not_available": "غير متاح",
"orders.other": "أخرى",
"orders.enter_reject_reason": "أدخل سبب الرفض",
"orders.reject_item_confirmation": "هل أنت متأكد من رفض هذا الصنف؟",
"orders.confirm_rejection": "تأكيد الرفض",
"orders.page": "الصفحة {current} من {total}",  // موجودة بالفعل، لذا استخدمها

    // الأقسام[]
    "departments": "الأقسام",
    "departments.department": "القسم",
    "departments.eastern-sweets": "الحلويات الشرقية",
    "departments.western-sweets": "الحلويات الغربية",
    "departments.bakery": "المخبوزات",
    "departments.chocolate": "الشوكولاتة",
    "departments.bread": "الخبز",
    "departments.pastries": "المعجنات",
    "departments.cakes": "الكعك",
    "departments.unknown": "قسم غير معروف",
  "orders.status_rejected": "مرفوض",
  "orders.status_assigned" : "معين لك",
    // المنتجات
    "products": "المنتجات",
    "products.manage": "إدارة المنتجات",
    "products.add": "إضافة منتج",
    "products.name": "اسم المنتج",
    "products.code": "كود المنتج",
    "products.category": "القسم",
    "products.price": "السعر بالريال",
    "products.unknown": "منتج غير معروف",
    "products.baklava": "بقلاوة مشكلة",
    "products.kunafa": "كنافة نابلسية",
    "products.maamoul": "معمول تمر",


    "confirm_delivery_title": "تأكيد استلام الطلب #{number}",

    // الأخطاء
    "errors.server_error": "خطأ في الخادم، يرجى المحاولة لاحقًا",
    "errors.fetch_orders": "فشل في جلب الطلبات",
    "errors.update_order_status": "حدث خطأ أثناء تحديث حالة الطلب",
    "errors.assign_chef": "فشل في تعيين الشيف",
    "errors.order_not_found": "الطلب غير موجود",
    "orders.search_placeholder": "ابحث برقم الطلب، المنتج، أو الملاحظات",
    "errors.invalid_input": "بيانات غير صحيحة",
    "errors.unauthorized_access": "غير مخول للوصول",
    "errors.no_branch_assigned": "لم يتم تخصيص فرع",
    "errors.insufficient_stock": "المخزون غير كافٍ",
    "errors.exceeds_max_quantity": "الكمية تتجاوز الحد الأقصى",
    "errors.invalid_quantity": "الكمية غير صالحة",
    "errors.empty_cart": "السلة فارغة",
    "errors.fetch_sales": "فشل جلب المبيعات",
    "errors.create_sale_failed": "فشل إنشاء المبيعة",


"orders.number": "رقم ",
"orders.products": "المنتجات",
"	orders.actions": "الإجراءات",

    "orders.total_quantity": "إجمالي الكمية",
    "orders.confirm_delivery": "تأكيد التسليم",
    // حالات الطلب
    "order_status.pending": "قيد الانتظار",
    "order_status.confirmed": "مؤكد",
    "order_status.in_production": "قيد الإنتاج",
    "order_status.completed": "مكتمل",
    "order_status.in_transit": "في الطريق",
    "order_status.delivered": "تم التسليم",
    "order_status.cancelled": "ملغى",

    // الإشعارات
    "notifications.order_created": "تم إنشاء طلب رقم {orderNumber} من {branchName}",
    "notifications.item_completed": "تم إكمال {quantity} {productName} في طلب رقم {orderNumber}",
    "notifications.order_confirmed": "تم تأكيد استلام طلب رقم {orderNumber}",
    "notifications.task_assigned": "تم تعيين الشيف {chefName} لإنتاج {quantity} {productName} في طلب رقم {orderNumber} لفرع {branchName}",
    "notifications.item_status_updated": "تم تحديث حالة {quantity} {productName} في طلب رقم {orderNumber} لفرع {branchName}",
    "notifications.order_status_updated": "تم تحديث حالة طلب رقم {orderNumber} إلى {status}",
    "notifications.order_completed": "تم إكمال طلب لفرع {branchName} برقم {orderNumber} ويجب مراجعته قبل الشحن",
    "notifications.order_completed_for_branch": "تم إكمال طلبك رقم {orderNumber} ويتم تجهيزه للشحن",
    "notifications.order_shipped_for_branch": "تم شحن الطلب رقم {orderNumber} من المصنع وهو في طريقه إليكم",
    "notifications.order_delivered": "قام فرع {branchName} بتأكيد استلام الطلب رقم {orderNumber}",
    "notifications.order_delivered_for_branch": "تم تأكيد استلام طلب رقم {orderNumber}",
    "notifications.return_status_updated": "تم تحديث حالة إرجاع طلب رقم {orderNumber} إلى {status}",
    "notifications.missing_assignments": "يوجد عناصر غير معينة في طلب رقم {orderNumber}",
    "notifications.new_order_from_branch": "طلب جديد {orderNumber} من {branchName}",
    "notifications.order_approved_for_branch": "تم اعتماد الطلب {orderNumber} لـ {branchName}",
    "notifications.new_production_assigned_to_chef": "تم تعيينك لإنتاج عنصر في الطلب {orderNumber}",
    "notifications.order_in_transit_to_branch": "الطلب {orderNumber} في طريقه إلى {branchName}",
    "notifications.branch_confirmed_receipt": "تم تأكيد استلام الطلب {orderNumber} بواسطة {branchName}",
    "orders.update_selected_items_to" : "تحديث الأصناف المحددة إلى {status}",

    // السوكت
    "socket.connected": "تم الاتصال بالخادم بنجاح",
    "socket.disconnected": "تم قطع الاتصال بالخادم",
    "socket.error": "خطأ في الاتصال: {message}",
    "socket.reconnecting": "جاري إعادة الاتصال بالخادم",
    "socket.reconnected": "تمت إعادة الاتصال بالخادم بنجاح",
    "socket.order_created": "تم إنشاء طلب جديد: {orderNumber}",
    "socket.task_assigned": "تم تعيين الشيف {chefName} لإنتاج {quantity} {productName} في طلب رقم {orderNumber}",
    "socket.item_status_updated": "تم تحديث حالة {quantity} {productName} في طلب رقم {orderNumber} لفرع {branchName}",
    "socket.order_status_updated": "تم تحديث حالة الطلب إلى {status}",
    "socket.return_status_updated": "تم تحديث حالة المرتجع إلى {status}",
    "socket.missing_assignments": "الصنف {productName} لم يتم تعيين شيف له",
    "socket.task_completed": "تم إكمال المهمة بنجاح",
    "socket.order_completed": "تم إكمال الطلب بنجاح",
    "socket.branch_confirmed_receipt": "تم تأكيد استلام الطلب من قبل الفرع",
    "socket.order_approved": "تم اعتماد الطلب بنجاح",
    "socket.order_in_transit": "الطلب في مرحلة النقل",
    "socket.order_completed_by_chefs": "تم إكمال الطلب من قبل الشيفات"
  },
  "en": {
    // General
    "app.title": "el-Joudia",
    "app.subtitle": "Branch & Production Management System",
    "app.logo_alt": "Joudia Sweets Factory",
    "login": "Login",
    "logout": "Logout",
    "username": "Username",
    "sales.create": "Create new Sale",
    "password": "Password",
    "dashboard": "Dashboard",
    "dailyOrders": " Orders movement",
    "confirm_delivery_title" : "Confirm Delivery for Order #{orderNumber}",
    "save": "Save",
    "cancel": "Cancel",
    "edit": "Edit",
    "delete": "Delete",
    "add": "Add",
    "view": "View",
    "search": "Search",
    "filter": "Filter",
    "date": "Date",
    "status": "Status",
    "quantity": "Quantity",
    "price": "Price",
    "total": "Total",
    "branch": "Branch",
    "product": "Product",
    "category": "Category",
    "common.back": "Back",
    "common.retry": "Retry",
    "common.loading": "Loading...",
    "common.debug_info": "Debug Information",
    "common.user_role": "User Role",
    "common.token": "Token",
    "header.logout": "Logout",
    "settings": "profile",
    "orders.update_selected_items_to" : "Update selected items to {status}",
    "common.present": "Present",
    "common.absent": "Absent",
    "orders.page": "Page / of ",
    "orders.total_amount": "Total Amount",
    "orders.date": "Order Date",
    "pagination.previous": "Previous",
    "pagination.next": "Next",
    "orders.review": " orders Review",
    "sales.review": " sales Review",
    "productionTasks": " production tasks ",
    "returns-vs-orders": "returns vs orders",
    "orders.search_Placeholder": "Search by order number, product , or notes",
 "orders.confirm_delivery": "Confirm Delivery",
 "orders.total_quantity": "Total Quantity",

    "returns.review": " returns Review",

    "pagination.page": "Page {current} of {total}",

 "orders.status_rejected": "Rejected",
    "orders.more_items": "   more items",
"orders.show_less":  " show less",
    "orders.delivery_completed": "Delivery Completed",

    // Dashboards
    "admin.dashboard": "Admin Dashboard",
    "branch.dashboard": "Branch Dashboard",
    "chef.dashboard": "Chef Dashboard",
    "production.dashboard": "Production Dashboard",

    // Orders
    "orders": "Orders",
    "item_completed": "Item Completed",
    "item_pending": "Item Pending",
    "item_in_progress": "Item In Progress",
    "item_assigned": "Item Assigned",
    "item_approved": "Item Approved",
    "item_rejected": "Item Rejected",
    "item_in_production": "Item In Production",
    "orders.title": "Orders Management",
    "orders.subtitle": "View and manage all orders",
    "orders.new": "New Orders",
    "orders.pending": "Pending Review",
    "orders.approved": "Approved",
    "orders.in_production": "In Production",
    "orders.completed": "Completed",
    "orders.delivered": "Delivered",
    "orders.cancelled": "Cancelled",
    "orders.in_transit": "In Transit",
    "orders.create": "Create New Order",
    "orders.total": "Total Orders",
    "orders.allStatuses": "All Statuses",
    "orders.all_statuses": "All Statuses",
    "orders.branch": "Branch",
    "orders.items_count": "Items Count",
    "orders.itemsCount": "Items Count",
    "orders.totalAmount": "Total Amount",
    "orders.adjusted_total": "Adjusted Total",
    "orders.currency": "SAR",
    "orders.notes": "Notes",
    "orders.notes_label": "Notes",
    "orders.order": "Order",
    "orders.view": "View",
    "orders.approve": "Approve",
    "orders.cancel": "Cancel",
    "orders.startProduction": "Start Production",
    "orders.complete": "Complete",
    "orders.ship": "Ship",
    "orders.dailyOrdersSummary": " Orders Summary",
    "orders.loading": "Loading Orders...",
    "orders.fetchError": "Failed to fetch orders",
    "orders.timeoutError": "Request timed out, please try again",
    "orders.unauthorized": "Unauthorized, please log in again",
    "orders.invalidTransition": "Cannot change to this status",
    "orders.updateError": "Error updating order status",
    "orders.createError": "Error creating order",
    "orders.formError": "Please fill all required fields",
    "orders.noOrders": "No Orders Found",
    "orders.noOrdersFiltered": "No orders found for the selected status or search",
    "orders.no_orders": "No Orders Available",
    "orders.no_orders_subtitle": "No orders match the selected criteria",
    "orders.noOrdersYet": "No orders have been placed yet",
    "orders.filterStatus": "Filter by Status",
    "orders.filter_by_status": "Filter by Status",
    "orders.search": "Search Orders",
    "orders.searchPlaceholder": "Search by order number, branch, or notes",
    "orders.orderDetails": "Order Details",
    "orders.order_details": "Order Details #{orderNumber}",
    "orders.order_number": "Order Number",
    "orders.quantity": "Quantity",
    "orders.itemTotal": "Item Total",
    "orders.finalTotal": "Final Total",
    "orders.priority": "Priority",
    "orders.priority.low": "Low",
        "orders.updated_at": "Production At ",
        "orders.chef_tasks": "Production Tasks ",



        "orders.number": "Number ",
        "orders.products": "Products",
        "	orders.actions": "Actions",


    "orders.priority.medium": "Medium",
    "orders.priority.high": "High",
    "orders.priority.urgent": "Urgent",
    "orders.priority_low": "Low Priority",
    "orders.priority_medium": "Medium Priority",
    "orders.priority_high": "High Priority",
    "orders.priority_urgent": "Urgent Priority",
    "orders.deliveryDate": "Delivery Date",
    "orders.createdBy": "Created By",
    "orders.unknown": "Unknown",
    "orders.retry": "Retry",
    "orders.previous": "Previous",
    "orders.next": "Next",
    "orders.sort": "Sort By",
    "orders.sort_by": "Sort By",
    "orders.sort.date": "Date",
    "orders.sort_date": "Date",
    "orders.sort.total": "Total Amount",
    "orders.sort_total_amount": "Total Amount",
    "orders.sort.priority": "Priority",
    "orders.sort_priority": "Priority",
    "orders.sort.asc": "Ascending",
    "orders.sort.desc": "Descending",
    "orders.sort_order": "Sort Order",
    "orders.export": "Export as CSV",
    "orders.changeStatus": "Change Status",
    "orders.timeline": "Status Timeline",
    "orders.noNotes": "No Notes Available",
    "orders.item": "Item",
    "orders.items": "Items",
    "orders.addItem": "Add Item",
    "orders.selectBranch": "Select Branch",
    "orders.assign": "Assign to Chefs",
    "orders.assign_chefs": "Assign Chefs",
    "orders.assign_chefs_title": "Assign Chefs for Order #{orderNumber}",
    "orders.assign_chef_to": "Assign Chef to {product} (Quantity: {quantity})",
    "orders.assignedTo": "Assigned To",
    "orders.unassigned": "Unassigned",
    "orders.unassigned_items": "{count} Unassigned Items",
    "orders.select_chef": "Select Chef",
    "orders.fetchChefsError": "Failed to fetch chefs",
    "orders.assignError": "Please assign a chef to each item",
    "orders.no_chefs_selected": "No chefs selected",
    "orders.order_not_approved": "Order not yet approved",
    "orders.order_not_found": "Order not found",
    "orders.status_updated": "Order status updated to {status}",
    "orders.chefs_assigned": "Chefs assigned successfully",
    "orders.status_history": "Status History",
    "orders.progress": "Progress",
    "orders.returned": "Returned",
    "orders.reason": "Return Reason",
    "orders.review_notes": "Review Notes",
    "orders.created_at": "Created At",
    "orders.return_status": "Return Status",
    "orders.orders_count": "Orders Count: {count}",
    "orders.view_order": "View Order #{orderNumber}",
    "orders.approve_order": "Approve Order #{orderNumber}",
    "orders.cancel_order": "Cancel Order #{orderNumber}",
    "orders.assign_order": "Assign Order #{orderNumber}",
    "orders.ship_order": "Ship Order #{orderNumber}",
    "orders.item_status": "Item Status: {status}",
    "orders.item_pending": "Pending Assignment",
    "orders.item_assigned": "Assigned",
    "orders.item_in_progress": "In Progress",
    "orders.item_completed": "Completed",
    "orders.item_unknown": "Unknown Item Status",
    "orders.department": "Department",
    "orders.status.unknown": "Unknown Status",

    // Returns
    "returns": "Returns",
    "returns.new": "New Returns",
    "returns.pending": "Pending Review",
    "returns.approved": "Approved",
    "returns.rejected": "Rejected",
    "returns.processed": "Processed",
    "returns.reason": "Return Reason",
    "returns.create": "Register Return",
    "returns.review_notes": "Review Notes",
    "returns.created_at": "Created At",
    "returns.pending_approval": "Pending Approval",

    // Inventory
    "inventory": "Inventory",
    "inventory.available": "Available",
    "inventory.sold": "Sold",
    "inventory.returned": "Returned",
    "inventory.remaining": "Remaining",

    // Reports
    "reports": "Statistics & Reports",
    "reports.daily": "Daily",
    "reports.weekly": "Weekly",
    "reports.monthly": "Monthly",
    "reports.yearly": "Yearly",
    "reports.top-branches": "Top Ordering Branches",
    "reports.low-branches": "Low Ordering Branches",
    "reports.top-products": "Most Ordered Products",
    "returns.top-returns": "Most Returned Products",

    // Branches
    "branches": "Branches",
    "branches.manage": "Manage Branches",
    "branches.add": "Add Branch",
    "branches.name": "Branch Name",
    "branches.unknown": "Unknown Branch",
    "branches.riyadh": "Riyadh Branch",
    "branches.jeddah": "Jeddah Branch",
    "branches.dammam": "Dammam Branch",
    "branches.all_branches": "All Branches",
    "branches.select_branch": "Select Branch",

    // Chefs
    "chefs": "Chefs",
    "chefs.manage": "Manage Chefs",
    "chefs.add": "Add Chef",
    "chefs.name": "Chef Name",
    "chefs.named": "Chef {name}",
    "chefs.department": "Department",
    "_orders.status": " all statuses",
    "orders.status_pending": " pending",
    "orders.status_approved": " approved",
    "orders.status_in_production": " in production",
    "orders.status_completed": " completed",
    "orders.status_in_transit": " in transit",
    "orders.status_delivered": " delivered",
    "orders.status_cancelled": " cancelled",
    "chefs.unknown": "Unknown Chef",
    "chefs.all_chefs": "All Chefs",
    "chefs.select_chef": "Select Chef",
  

    "Production-Report": "Production Summary",
    // Sales
    "sales": "Sales",
    "sales.daily": "Daily Sales",
    "sales.register": "Register Sale",
    "sales.amount": "Sales Amount",
    "salesReport.title": "Sales Report",
    "salesReport.subtitle": "Manage Sales and Monitor Performance",
    "salesReport.availableProducts": "Available Products",
    "salesReport.noProducts": "No Products Available",
    "salesReport.cart": "Sales Cart",
    "salesReport.emptyCart": "Cart is Empty",
    "salesReport.previousSales": "Previous Sales",
    "salesReport.noSales": "No Sales Available",
    "salesReport.filters": "Filters",
    "salesReport.department": "Department",
    "salesReport.availableStock": "Available Stock",
    "salesReport.unitPrice": "Unit Price",
    "salesReport.addToCart": "Add to Cart",
    "salesReport.total": "Total",
    "salesReport.notes": "Notes",
    "salesReport.submitSale": "Submit Sale",
    "salesReport.date": "Date",
    "salesReport.quantity": "Quantity",
    "salesReport.returns": "Returns",
    "salesReport.reason": "Reason",
    "salesReport.branchSales": "Branch Sales",
    "salesReport.productSales": "Product Sales",
    "salesReport.departmentSales": "Department Sales",
    "salesReport.sale_success": "Sale Created Successfully",

    // Departments
    "departments": "Departments",
    "departments.department": "Department",
    "departments.eastern-sweets": "Eastern Sweets",
    "departments.western-sweets": "Western Sweets",
    "departments.bakery": "Bakery",
    "departments.chocolate": "Chocolate",
    "departments.bread": "Bread",
    "departments.pastries": "Pastries",
    "departments.cakes": "Cakes",
    "departments.unknown": "Unknown Department",

    // Products
    "products": "Products",
    "products.manage": "Manage Products",
    "products.add": "Add Product",
    "products.name": "Product Name",
    "products.code": "Product Code",
    "products.category": "Category",
    "products.price": "Price (SAR)",
    "products.unknown": "Unknown Product",
    "products.baklava": "Mixed Baklava",
    "products.kunafa": "Nabulsi Kunafa",
    "products.maamoul": "Date Maamoul",

    // Errors
    "errors.server_error": "Server error, try again later",
    "errors.fetch_orders": "Failed to fetch orders",
    "errors.update_order_status": "Error updating order status",
    "errors.assign_chef": "Failed to assign chef",
    "errors.order_not_found": "Order not found",
    "errors.invalid_input": "Invalid input",
    "errors.unauthorized_access": "Unauthorized access, please log in again",
    "errors.no_branch_assigned": "No branch assigned",
    "errors.insufficient_stock": "Insufficient stock",
    "errors.exceeds_max_quantity": "Quantity exceeds maximum limit",
    "errors.invalid_quantity": "Invalid quantity",
    "errors.empty_cart": "Cart is empty",
    "errors.fetch_sales": "Failed to fetch sales",
    "errors.create_sale_failed": "Failed to create sale",

    // Notifications
    "notifications.order_created": "New order #{orderNumber} created from {branchName}",
    "notifications.item_completed": "Completed {quantity} {productName} in order #{orderNumber}",
    "notifications.order_confirmed": "Order #{orderNumber} receipt confirmed",
    "notifications.task_assigned": "Chef {chefName} assigned to produce {quantity} {productName} in order #{orderNumber} for {branchName}",
    "notifications.item_status_updated": "Status updated for {quantity} {productName} in order #{orderNumber} for {branchName}",
    "notifications.order_status_updated": "Order #{orderNumber} status updated to {status}",
    "notifications.order_completed": "Order #{orderNumber} for {branchName} completed and needs review before shipping",
    "notifications.order_completed_for_branch": "Your order #{orderNumber} is completed and being prepared for shipping",
    "notifications.order_shipped_for_branch": "Order #{orderNumber} shipped from the factory and is on its way",
    "notifications.order_delivered": "Branch {branchName} confirmed receipt of order #{orderNumber}",
    "notifications.order_delivered_for_branch": "Receipt confirmed for order #{orderNumber}",
    "notifications.return_status_updated": "Return status for order #{orderNumber} updated to {status}",
    "notifications.missing_assignments": "Unassigned items found in order #{orderNumber}",
    "notifications.new_order_from_branch": "New order #{orderNumber} from {branchName}",
    "notifications.order_approved_for_branch": "Order #{orderNumber} approved for {branchName}",
    "notifications.new_production_assigned_to_chef": "You have been assigned to produce an item for order #{orderNumber}",
    "notifications.order_in_transit_to_branch": "Order #{orderNumber} is in transit to {branchName}",
    "notifications.branch_confirmed_receipt": "Order #{orderNumber} receipt confirmed by {branchName}",

    // Socket
    "socket.connected": "Successfully connected to the server",
    "socket.disconnected": "Disconnected from the server",
    "socket.error": "Connection error: {message}",
    "socket.reconnecting": "Reconnecting to the server...",
    "socket.reconnected": "Successfully reconnected to the server",
    "socket.order_created": "New order created: {orderNumber}",
    "socket.task_assigned": "Chef {chefName} assigned to produce {quantity} {productName} in order #{orderNumber}",
    "socket.item_status_updated": "Status updated for {quantity} {productName} in order #{orderNumber} for {branchName}",
    "socket.order_status_updated": "Order status updated to {status}",
    "socket.return_status_updated": "Return status updated to {status}",
    "socket.missing_assignments": "Item {productName} is missing a chef assignment",
    "socket.task_completed": "Task completed successfully",
    "socket.order_completed": "Order completed successfully",
    "socket.branch_confirmed_receipt": "Branch confirmed receipt of the order",
    "socket.order_approved": "Order approved successfully",
    "socket.order_in_transit": "Order is in transit",
    "socket.order_completed_by_chefs": "Order completed by chefs"
  }
}


export function LanguageProvider({ children }: { children: ReactNode }) {
  const [language, setLanguage] = useState<Language>('ar');

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language') as Language;
    if (savedLanguage) {
      setLanguage(savedLanguage);
    }

    // Update document direction and language
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = language;
  }, [language]);

  const toggleLanguage = () => {
    const newLanguage = language === 'ar' ? 'en' : 'ar';
    setLanguage(newLanguage);
    localStorage.setItem('language', newLanguage);
    document.documentElement.dir = newLanguage === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = newLanguage;
  };

  const t = (key: string, params: { [key: string]: string | number | undefined } = {}): string => {
    let translation = translations[language][key] || key;
    Object.entries(params).forEach(([param, value]) => {
      const replacement = value != null ? value.toString() : translations[language]['orders.unknown'] || 'Unknown';
      translation = translation.replace(`{${param}}`, replacement);
    });
    return translation;
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}